// lib/api.js
import { supabase } from './supabaseClient'; // your existing supabase client
import { MY_BACKEND_URL } from './supabaseClient';
import { DUMMY_ROWS } from '../Components/Analysis/Utility/Utility';

export async function checkTestResponses(testId) {
  const { data: { session } } = await supabase.auth.getSession();
  
  if (!session) throw new Error("Not logged in");

  const response = await fetch(`${MY_BACKEND_URL}/api/check-responses`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${session.access_token}`
    },
    body: JSON.stringify({ testId })
  });

  const data = await response.json();
  
  if (!response.ok) throw new Error(data.error || "Something went wrong");
  
  return data;
}

export async function fetchResponses(testId, questionId) {
  const { data, error } = await supabase
    .from("responses")
    .select("*")
    .eq("test_id", testId)
    .eq("question_id", questionId);

  if (error) throw error;
  return data; // raw rows
}